import DeactivateEmployeeModal from "./DeactivateEmployeeModalContainer";

export default DeactivateEmployeeModal;
